module.exports = __webpack_public_path__ + "static/speech-recognition-d7d01c3db1b59724416588b1688d5764.jpg";